import {SceneJsonExporterData} from '../../polygonjs-editor/@polygonjs/polygonjs/src/engine/io/json/export/Scene';
import {
	SceneDataImportOptions,
	ScenePlayerImporter,
} from '../../polygonjs-editor/@polygonjs/polygonjs/src/engine/io/player/Scene';

export function waitForDocumentLoaded() {
	return new Promise((resolve) => {
		document.addEventListener('DOMContentLoaded', resolve);
	});
}

async function loadScene(
	sceneData: SceneJsonExporterData,
	sceneName: string,
	sceneUuid: string,
	assetsRoot: string | null
) {
	const domElement = document.getElementById('app');
	if (domElement) {
		// set viewport ratio
		const viewport_ratio_str = domElement.dataset['viewportRatio'];
		const parent = domElement.parentElement;
		if (parent && viewport_ratio_str) {
			const viewport_ratio = parseFloat(viewport_ratio_str);
			parent.style.height = `${parent.offsetWidth / viewport_ratio}px`;
		}

		// load scene
		// const scene = await SceneJsonImporter.loadData(code);
		const options: SceneDataImportOptions = {
			sceneData,
			domElement,
			sceneName,
			createViewer: true,
			configureScene: (scene) => {
				scene.assets.setRoot(assetsRoot);
			},
			onProgress: (progress) => {
				// console.log(progress);
			},
			autoPlay: true,
		};
		const data = await ScenePlayerImporter.loadSceneData(options);
		const {scene, viewer} = data;
		// console.log(scene, viewer);

		window.scene = scene;
		if (!viewer) {
			console.warn('viewer not created');
			return;
		}
		// scene.setName(scene_name);
		// scene.setUuid(scene_uuid);
		// scene.assets.setRoot(assets_root);
		// const viewer = await scene.camerasController.createMainViewer();
		// if (!viewer) {
		// 	console.warn('no viewer created');
		// 	return;
		// }
		viewer.mount(domElement);
		// set_play_pause_events(scene);
		// wait before playing, otherwise particle systems would appear after having already simulated several time steps
		// scene.waitForCooksCompleted().then(() => {
		const loading_container = document.getElementById('scene_loading_container');
		if (loading_container) {
			loading_container.classList.add('fading');
			setTimeout(() => {
				if (loading_container && loading_container.parentElement) {
					loading_container.parentElement.removeChild(loading_container);
				}
			}, 200);
		}
		// scene.play();
		// });
	} else {
		console.warn('no element #app found');
	}
}
// function set_play_pause_events(scene: PolyScene) {
// 	const controls_back = document.body.querySelector('[data-controls=back]') as HTMLElement;
// 	const controls_pause = document.body.querySelector('[data-controls=pause]') as HTMLElement;
// 	const controls_play = document.body.querySelector('[data-controls=play]') as HTMLElement;
// 	if (controls_back && controls_pause && controls_play) {
// 		controls_play.style.display = 'none';
// 		controls_back.addEventListener('click', () => scene.setFrame(1));
// 		controls_pause.addEventListener('click', () => {
// 			scene.pause();
// 			controls_pause.style.display = 'none';
// 			controls_play.style.display = 'inline-block';
// 		});
// 		controls_play.addEventListener('click', () => {
// 			scene.play();
// 			controls_pause.style.display = 'inline-block';
// 			controls_play.style.display = 'none';
// 		});
// 	}
// }

let _loadFromElementDatasetStarted = false;
export function loadFromElementDataset() {
	if (_loadFromElementDatasetStarted) {
		return;
	}
	_loadFromElementDatasetStarted = true;
	const element = document.getElementById('scene-data');
	if (element) {
		const scene_uuid = element.dataset['uuid'];
		const scene_name = element.dataset['name'];
		const code_str = element.dataset['code'];
		const assets_root = element.dataset['assetsRoot'] || null;
		if (code_str && scene_name && scene_uuid) {
			const code = JSON.parse(code_str);
			loadScene(code, scene_name, scene_uuid, assets_root);
		} else {
			console.log('no code dataset');
		}
	} else {
		console.warn('no scene element found');
	}
}

// export function addOnDocumentLoadScene() {
// 	document.addEventListener('DOMContentLoaded', _loadFromElementDataset);
// 	_loadFromElementDatasetStarted;
// }
